import React from 'react';
import { Outlet } from 'react-router-dom';
import './AuthLayout.css'; // optional for scoped styling

const AuthLayout = () => {
  return (
    <div className="auth-wrapper">
      <div className="auth-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;